import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
type Staff = {
  role: string;
  name: string;
  padi: string;
  description: string;
};
const staff: Staff[] = [{
  role: 'Instructor a cargo del viaje',
  name: 'Mauro Aníbal Mariscotti',
  padi: '#397148',
  description: 'Trabajó durante años en Fernando de Noronha y conoce el destino en profundidad. Su experiencia local permite coordinar cada detalle del viaje, compartir recomendaciones únicas y acompañar al grupo desde una perspectiva que muy pocos profesionales tienen sobre la isla.'
}, {
  role: 'Asesor de viaje y atención personalizada',
  name: 'Fernando J. Álvarez',
  padi: '#342282',
  description: 'Disponible para acompañarte antes del viaje y resolver cualquier consulta relacionada con reservas, certificaciones, equipamiento, requisitos y planificación para que llegues a Fernando de Noronha con todo organizado.'
}];
function StaffCard({
  member,
  delay = 0
}: {
  member: Staff;
  delay?: number;
}) {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    delay,
    duration: 0.5,
    ease: 'easeOut'
  }} className="bg-noronha-graphite rounded-2xl border border-noronha-petroleum/30 p-7 md:p-9" data-id="element-377">
      <span className="font-mono text-xs md:text-sm tracking-[0.18em] uppercase text-noronha-emerald block mb-4" data-id="element-378">
        {member.role}
      </span>
      <h3 className="font-heading text-2xl md:text-3xl font-bold text-noronha-text-heading tracking-tight mb-3 text-balance" data-id="element-379">
        {member.name}
      </h3>
      <div className="flex items-center gap-3 mb-5" data-id="element-380">
        <span className="text-noronha-text-body text-base md:text-lg" data-id="element-381">
          Instructor PADI
        </span>
        <span className="font-mono text-xs md:text-sm text-noronha-text-heading bg-noronha-volcanic/80 border border-noronha-petroleum/40 rounded-md px-2.5 py-1" data-id="element-382">
          {member.padi}
        </span>
      </div>
      <p className="text-noronha-text-body text-base md:text-lg leading-relaxed" data-id="element-383">
        {member.description}
      </p>
    </motion.article>;
}
export function OrganizadoPor() {
  return <section className="relative bg-noronha-volcanic py-24 md:py-32" data-id="element-384">
      <div className="container mx-auto px-6" data-id="element-385">
        <div className="max-w-2xl mx-auto" data-id="element-386">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16" data-id="element-387">
            <motion.span initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-mono text-xs md:text-sm tracking-[0.22em] uppercase text-noronha-emerald block mb-5" data-id="element-388">
              Organizado por
            </motion.span>
            <motion.h2 initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-noronha-text-heading tracking-tight text-balance mb-7" data-id="element-389">
              Buceo y Navegación
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-noronha-text-body text-lg md:text-xl leading-relaxed text-balance" data-id="element-390">
              Más de 10 años organizando viajes grupales de buceo y creando
              experiencias inolvidables en algunos de los destinos más
              increíbles del mundo.
            </motion.p>
          </div>

          {/* Staff cards */}
          <div className="flex flex-col gap-6 md:gap-8 mb-12 md:mb-14" data-id="element-391">
            {staff.map((member, i) => <StaffCard key={member.name} member={member} delay={i * 0.1} data-id="element-392" />)}
          </div>

          {/* Instagram button */}
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: 'easeOut'
        }} className="flex justify-center" data-id="element-393">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-7 py-3.5 rounded-full bg-white text-slate-900 font-heading font-semibold text-sm md:text-base tracking-wide hover:shadow-[0_8px_30px_rgba(255,255,255,0.15)] hover:-translate-y-0.5 transition-all duration-300" data-id="element-394">
              <Instagram className="w-5 h-5" strokeWidth={1.75} data-id="element-395" />
              Seguinos en Instagram
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}